import { render, staticRenderFns } from "./SupplierReturnSummary.vue?vue&type=template&id=50db011c&"
import script from "./SupplierReturnSummary.vue?vue&type=script&lang=js&"
export * from "./SupplierReturnSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports